import { createSlice } from "@reduxjs/toolkit";
import { fetchFromStorage, removeFromStorage, saveToStorage } from "../../storage";

interface SearchedDataState {
  searchedData: any;
  searchFormData: any;
  venueList: any;
  selectedOrgForCosting: any,
  eventTypeList: any,
}
const searchedDataSlice = createSlice({
  name: "searchedDataSlice",
  initialState: {
    searchedData: JSON.parse(
      fetchFromStorage("searchedData", true) as string) || [],
    searchFormData: JSON.parse(
      fetchFromStorage("searchFormData", true) as string) || {},
    venueList: {},
    selectedOrgForCosting: fetchFromStorage("selectedOrgForCosting", true),
    eventTypeList: []
  },
  reducers: {
    setSearchedData(state, action) {
      state.searchedData = action.payload;
      saveToStorage('searchedData', JSON.stringify(action.payload), true);
    },
    setSearchFormData(state, action) {
      state.searchFormData = action.payload;
      saveToStorage('searchFormData', JSON.stringify(action.payload), true);
    },
    setVenueList(state, action) {
      state.venueList = action.payload;
    },
    setSelectedOrg(state, action) {
      state.selectedOrgForCosting = action.payload;
      saveToStorage('selectedOrgForCosting', JSON.stringify(action.payload), true);
    },
    setEventTypeList(state, action) {
      state.eventTypeList = action.payload;
      saveToStorage('eventTypeList', JSON.stringify(action.payload), true);
    },
    setSearchDataSliceInitState(state, action) {
      state.searchedData = [];
      removeFromStorage('searchedData', true);
      state.searchFormData = {};
      removeFromStorage('searchFormData', true);
      state.venueList = {};
      state.selectedOrgForCosting = null;
      removeFromStorage('selectedOrgForCosting', true);
    }
  },

});

export default searchedDataSlice.reducer;

export const { setSearchedData, setSearchFormData, setVenueList, setSelectedOrg, setSearchDataSliceInitState, setEventTypeList } = searchedDataSlice.actions;

export const searchedData = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.searchedData;
export const searchFormData = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.searchFormData;
export const venueList = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.venueList;
export const selectedOrgForCosting = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.selectedOrgForCosting;
export const eventTypeList = (state: { searchedDataSlice: SearchedDataState }) =>
  state.searchedDataSlice.eventTypeList;


